export const capitalizeFirstLetter = (text) => text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();

export const capitalizeAll = (text) => text.split(' ').map(capitalizeFirstLetter).join(' ');
